import { EMPTY_PLACEHOLDER } from 'Data/constants.js'
import { listEquals } from 'Data/aggregate.js'

function keyValues(obj, separator = ', ') {
  let keys = obj.displayValues || Object.keys(obj)

  let getValue = (path, source) => {
    let parts = path.split('.')
    let value = source
    for (let i = 0; i < parts.length; i++) {
      if (value == null) return undefined
      value = value[parts[i]]
    }
    return value
  }

  return keys.map(key => getValue(key, obj)).join(separator)
}

export function questionsAndAnswers(
  flowQuestions,
  questions,
  answers,
  current_question_id
) {
  let answered = flowQuestions
    .map(item => {
      let questionDetails = questions?.find(question => question.id === item)

      if (
        answers?.[item] !== null &&
        answers?.[item] !== undefined &&
        !questionDetails.isInformationOnly
      ) {
        if (answers[item]?.skipped) {
          return { ...questionDetails, answerValue: '-' }
        }

        return {
          ...questionDetails,
          answerValue: Array.isArray(answers?.[item])
            ? answers[item].map(keyValues).join(', ')
            : typeof answers?.[item] === 'object'
            ? keyValues(answers[item])
            : answers?.[item],
        }
      }
      return false
    })
    .filter(Boolean)

  let required = questions
    .map(item => {
      return item.required && flowQuestions.includes(item.id) ? item.id : false
    })
    .filter(Boolean)

  let done = answered.map(item => item.id)

  if (listEquals(required, done)) {
    return answered
  }

  return [
    ...answered,
    flowQuestions?.length !== Object.keys(answers).length && {
      ...questions?.find(
        item =>
          item.id ===
          flowQuestions.filter(
            question => !Object.keys(answers).includes(question)
          )[0]
      ),
      answerValue: EMPTY_PLACEHOLDER,
    },
  ].filter(Boolean)
}
